import PageRecord from "models/view-models/page-record";
import PageService from "utilities/services/notebooks/page-service";
import useNotebooksAtom from "utilities/hooks/domain/notebooks/use-notebooks-atom";
import { ResultErrorRecord } from "@rsm-hcd/javascript-core";
import { t } from "i18next";
import { useState } from "react";
import { CollectionUtils } from "utilities/collection-utils";

export const DEFAULT_ERROR_KEY = "Error.PageDeletionFailed";
const DEFAULT_ERROR_MESSAGE = t("page-error-deletePage");

interface UseDeletePageOptions {
    page?: PageRecord;
    onSuccess?: () => void;
}

/**
 * Custom hook to wrap up the API calls to delete Pages.
 */
export function useDeletePage(options: UseDeletePageOptions) {
    const { page, onSuccess } = options;
    const { delete: deletePageApi } = PageService.useDelete();
    const { removePageFromNotebook } = useNotebooksAtom();
    const [errors, setErrors] = useState<ResultErrorRecord[]>([]);

    const [loading, setLoading] = useState(false);

    const deletePage = async () => {
        setLoading(true);
        setErrors([]);
        try {
            const response = await deletePageApi(page?.id!);
            if (response.result?.hasErrors()) {
                if (CollectionUtils.isEmpty(response.result?.errors)) {
                    throw Error;
                }

                setErrors(response.result?.errors);
                return;
            }

            removePageFromNotebook(page?.id!, page?.notebookId!);
            onSuccess?.();
        } catch (error) {
            setErrors([
                new ResultErrorRecord({
                    key: DEFAULT_ERROR_KEY,
                    message: DEFAULT_ERROR_MESSAGE,
                }),
            ]);
        } finally {
            setLoading(false);
        }
    };

    return { deletePage, loading, errors: errors };
}
